import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.string.trim.js";
import { getServerOpenDayCount } from "@/api/data";
import VxeTable from "@/components/vxeTable/vxeTable.vue";
import infoList from "@/mixins/infoList";
import DataOptions from "../../components/timeList/dataOptions.vue";
import serverList from "../../components/serverList/serverOptions.vue";
export default {
  mixins: [infoList],
  components: {
    serverList: serverList,
    VxeTable: VxeTable,
    DataOptions: DataOptions
  },
  data: function data() {
    var h = this.$createElement;
    return {
      listApi: getServerOpenDayCount,
      searchInfo: {},
      formData: [this.$moment().subtract(1, "years").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      tableColumn: [{
        field: "server_name",
        title: "服务器",
        sortable: true,
        slots: {
          default: function _default(_ref) {
            var row = _ref.row;
            var serverName = row.server_name.trim();
            if (serverName) {
              return [h("span", [serverName])];
            } else {
              return [h("span", [row.server_id, "\u670D"])];
            }
          }
        }
      }, {
        field: "open_time_str",
        title: "开服时间",
        sortable: true
      }, {
        field: "new_user",
        title: "新增账号",
        sortable: true
      }, {
        field: "new_role",
        title: "创角",
        sortable: true
      }, {
        field: "activity_user",
        title: "活跃角色",
        sortable: true
      }, {
        field: "vip_role",
        title: "VIP角色",
        sortable: true
      }, {
        field: "new_role_pay_money",
        title: "新增付费金额",
        sortable: true,
        titleHelp: {
          "content": "新增付费金额（新增付费ARRPU）"
        },
        slots: {
          default: function _default(_ref2) {
            var row = _ref2.row;
            return [h("span", [row.new_role_pay_money, "\u5143\uFF08", row.new_role_arppu, "\uFF09"])];
          }
        }
      }, {
        field: "new_role_pay",
        title: "新增付费人数",
        sortable: true,
        titleHelp: {
          "content": "新增付费人数（新增付费率）"
        },
        slots: {
          default: function _default(_ref3) {
            var row = _ref3.row;
            return [h("span", [row.new_role_pay, "\uFF08", row.new_role_pay_rate, "%\uFF09"])];
          }
        }
      }, {
        field: "keep_role_1_day",
        title: "创角次留",
        sortable: true,
        slots: {
          default: function _default(_ref4) {
            var row = _ref4.row;
            return [h("span", [row.keep_role_1_day, " \uFF08", row.keep_role_1_day_rate, "%\uFF09"])];
          }
        }
      }, {
        field: "pay_money",
        title: "付费金额",
        sortable: true,
        titleHelp: {
          "content": "付费金额（付费ARPPU）"
        },
        slots: {
          default: function _default(_ref5) {
            var row = _ref5.row;
            return [h("span", [row.pay_money, "\u5143\uFF08", row.pay_arppu, "\uFF09"])];
          }
        }
      }, {
        field: "pay_role",
        title: "付费人数",
        sortable: true,
        titleHelp: {
          "content": "付费人数（付费率）"
        },
        slots: {
          default: function _default(_ref6) {
            var row = _ref6.row;
            return [h("span", [row.pay_role, "\uFF08", row.pay_rate, "%\uFF09"])];
          }
        }
      }, {
        field: "arpu",
        title: "ARPU",
        sortable: true
      }, {
        field: "roll_role",
        title: "滚服创角数",
        sortable: true
      }, {
        field: "roll_money",
        title: "滚服充值金额",
        sortable: true,
        slots: {
          default: function _default(_ref7) {
            var row = _ref7.row;
            return [h("span", [row.roll_money, " \u5143"])];
          }
        }
      }, {
        field: "roll_pay_role",
        title: "滚服付费人数",
        sortable: true
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.searchEvent();
            _this.footDataToFirst();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    searchEvent: function searchEvent() {
      this.searchInfo.sdate = this.formData[0];
      this.searchInfo.edate = this.formData[1];
      this.loadTatleData();
    },
    loadTatleData: function loadTatleData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.getTableData();
            case 2:
              if (!_this2.total) {
                _this2.$message({
                  message: "暂无数据"
                });
              }
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    footDataToFirst: function footDataToFirst() {
      var arr1 = document.getElementsByClassName("vxe-table--footer-wrapper");
      var arr2 = document.getElementsByClassName("vxe-table--body-wrapper");
      console.log("arr2[0]", arr2);
      if (arr2[0]) {
        arr2[0].parentNode.insertBefore(arr1[0], arr2[0]);
      }
    }
  }
};